export default "__VITE_ASSET__8thWeGdc__";